import React from "react";
import style from "./index.module.css"
import add_icon from "../../assets/images/icons/icon-add.svg"
import more_icon from "../../assets/images/icons/icon-more-two.svg"
import {ReactComponent as TrashIcon} from "assets/images/icons/icon-trash.svg"
import {ReactComponent as ChangeIcon} from "assets/images/icons/icon-edit.svg"
import {ReactComponent as MoreIcon} from "assets/images/icons/icon-more-two.svg"
import person1 from "../../assets/images/img-person-one.png"
import Table from "../../components/Table";
import MoreBtn from "components/MoreBtn";
const Requests = () => {
    const more = [
        {
            text: "Детали",
            image: <ChangeIcon />,
            id: 3
        },
        {
            text: "Изменить",
            image: <ChangeIcon />,
            id: 1
        },
        {
            text: "Удалить",
            image: <TrashIcon/>,
            id: 2
        }
    ]
    let data = {
        header: [
            {
                content: "Запросы"
            },
            {
                content: "Добавил"
            },
            {
                content: "Ответственный"
            },
            {
                content: "Дата"
            },
            {
                content: <div><img src={more_icon} /></div>,
                type: "html"
            }
        ],
        body: [
            [{
                content: "Купить одноразовые вилки и ложки"
            },
            {
                content: "Тимур Бекмамбетов"
            },
            {
                content: "Тимур Бекмамбетов"
            },
            {
                content: "05.11.2022"
            },
            {
                content: <MoreBtn more={more} more_icon_btn={<MoreIcon />}/>,
                type: "html"
            }]
        ]
    }
    return (
        <div className={style.wrapper}>
            <div className={style.section_head}>
                <p className={style.title}>Запросы</p>
                <button className={style.add_btn} onclick="handleOpenPopup()">
                    <img src={add_icon} alt="icon add" />
                    Создать новый
                </button>
            </div>

            <div className={style.tabel_wrapper}>
                <Table data={data} />
            </div>
        </div>
    )
}

export default Requests;